export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS'

export default () => ({
  type: RESET_NOTIFICATIONS,
})
